export const m = {

  /**********************通用Start************************ */
  add: "Add",
  delete: "Delete",
  handle: "Handle",
  deleted: "Deleted",
  /**********************通用End************************ */


  amazonOrder: 'Amazon Order',
  manualOrder: 'Manual Order',
  orderSource: "Order Source",
  buyNotes: "Buy Messages",
  qty: "quantity",
  unitPrice: "Unit Price",
  total: "Total Price",
  postage: "Postage",
  itemTotal: "Item Total",
  skuName: "Product Name",
  inputSku: "Input Sku",
  img: "Image",

  isDefaultAddress: "Default Address",
  isNotDefaultAddress: "Input Address",
  customerName: "Customer Name",
  customerPhone: "Customer Phoneu",
  street1: "Street1",
  street2: "Street2",
  suburb: "Suburb",
  state: "Sstate",
  email: "Emailu",
  zip: "Zip Code",
  countryCode: "Country Code",
  sumitForm: "Submit",
  cancelForm: "Cancel",

  deliveryType: "Delivery Method",

  addressSelect: "Choose from existing addresses",
  addressAdd: "Manual Input address",
  addressAlarm: "Please choose an address",

  systemEmail: 'System email',

  orderFrom: "Select the source of the order",
  orderDate: "Order Date",
  purchaseOrderDate: "Purchase Order Date",
  btnAddInvoice: "add invoice address",
  //商品------------------------------------------------------
  spu_nowCategory: "Current category",
  spu_selectedCategroy: "Selected category",
  spu_fillProductInfo: "Fill in product information",
  spu_fillProductAttribute: "Fill in product attributes",
  spu_productCategory: "Categories",
  spu_fromUrl: "Source page url",
  spu_shorName: "Chinese name for declaration",
  spu_supplier: "Supplier",
  spu_currency: "Currency Unit",
  spu_isPower: "Is 240V power?",
  spu_isSafe: "Is safety hazard?",
  spu_isSAAo: "Is SAAO certified?",
  spu_notSpecial: "This product is not recommended",
  spu_isSpecial: "This product is specially recommended",
  spu_makeTime: "Production time",
  spu_recommendations: "Recommendation Reason",
  spu_vedioCode: "Video code",
  spu_introduction: "Product English desciption",
  spu_descCn: "Product Chinese desciption",
  spu_pacakgeNum: "Packing quantity",
  spu_allowEbay: "Permitted to list on Ebay",
  spu_allowAmazon: "Permitted to list on Amazon",
  spu_allowShipping: "Permitted to list on Shipping",
  spu_type: "Product Type",
  spu_attributeTypes: "Attribute type",
  spu_specification: "Product specifications",
  spu_album: "Products Album",
  spu_uploadManual: "Upload instructions",
  spu_detailHtml: "Edit product description html",
  spu_copyHtml: "Copy complete html",
  spu_previousStep: "In the previous step, fill in the product information",
  spu_nextStep: "Next, fill in the product attributes",
  spu_submit: "Finish, submit the product",

  sku_code: "SKU CODE",
  sku_pic: "SKU Pic",
  sku_unitPrice: "Purchase Unit Price",
  sku_length: "Length-mm",
  sku_width: "Width-mm",
  sku_height: "High-mm",
  sku_weight: "Weight-g",
  sku_sales_price: "sales price",
  sku_sp1: "Attributes 1",
  sku_sp2: "Attributes 2",
  sku_sp3: "Attributes 性3",
  sku_name: "Sku Name",
  sku_handle: "Handle",
  sku_delete: "Delete SKU",
  sku_discontinue: "Discontinue SKU",
  sku_recover: "Restore SKU",
  sku_refresh: "refresh the list",


  selectPurchaseType: "Select Purchase Type",
  overtimeType: "Timeout Type",
  orderChinaExpressOverTime: "Order -> China Express timeout",
  chinaExpressSeaOverTime: "China Express -> Sea freight timeout",
  seaMilperraOverTime: "Sea freight -> Milperra timeout",
  MilperraDeliveryOverTime: "Milperra -> Shipping timeout",
  dropshippingNote1: " Deleted flag means that the purchase requirement is deleted",
  dropshippingNote2: "If you confirm that a process does not need to be tracked, click Edit Notes and enter '已买' to hide the process.",
  chinaTrackingCreateTime: "China express number creation  date",
  internationTrackingCreatedTime: "International express number creation time",
  estimatedArrivalAusTime :"Estimated time of arrival in Australia",
  MilperraInStockTime:"Milperra InStock Time",
  requirementCreationDate:"Requirement creation date",
  OpenOrderQty:"Open Order Qty",
  PendingOrderQty:"Pending Order Qty",

  add_notes_alrt:"Are you sure to submit product notes?"




















}


// WEBPACK FOOTER //
// ./src/common/lang/en.js